import { Component, OnInit } from '@angular/core';
import { faCircle } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-email-status',
  templateUrl: './email-status.component.html',
  styleUrls: ['./email-status.component.scss'],
})
export class EmailStatusComponent implements OnInit {
  public status: string;

  circle = faCircle;

  get statusTooltip(): string {
    switch (this.status) {
      case 'ok':
        return '🟢 Green dot\n\nCampaign is not marked as deleted, and\nCampaign is active';
      case 'warning':
        return '🟡 Yellow dot\n\nCampaign is not marked as deleted, but\nCampaign is not active';
      case 'danger':
        return '🔴 Red dot\n\nCampaign is marked as deleted';
      default:
        return '';
    }
  }

  constructor() {}

  ngOnInit() {}
}
